var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-suggestions-row",
      style: { background: _vm.colors.messageList.bg }
    },
    _vm._l(_vm.suggestions, function(suggestion, idx) {
      return _c(
        "button",
        {
          key: idx,
          staticClass: "sc-suggestions-element",
          style: {
            borderColor: _vm.colors.sentMessage.bg,
            color: _vm.colors.sentMessage.bg
          },
          on: {
            click: function($event) {
              return _vm.$emit("sendSuggestion", suggestion)
            }
          }
        },
        [_vm._v(_vm._s(suggestion))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11adff40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11adff40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/Suggestions.vue
// module id = 1943
// module chunks = 116